const CodeEmployeeCategoryList = () =>
  import(/* webpackChunkName: "main_app" */ "./pages/ListPage.vue");
const CodeEmployeeCategoryDetail = () =>
  import(/* webpackChunkName: "main_app" */ "./pages/FormPage.vue");
const CodeEmployeeCategoryIndex = () =>
  import(/* webpackChunkName: "main_app" */ "./pages/IndexPage.vue");

export default [
  {
    path: "/code_employee_category",
    component: CodeEmployeeCategoryIndex,
    redirect: "/code_employee_category/list",
    name: "code_employee_category",
    children: [
      {
        path: "list",
        component: CodeEmployeeCategoryList,
        name: "code_employee_category.list",
      },
      {
        path: "create",
        component: CodeEmployeeCategoryDetail,
        name: "code_employee_category.create",
        props: { create: true },
      },
      {
        path: "edit/:id",
        component: CodeEmployeeCategoryDetail,
        name: "code_employee_category.edit",
        props: { create: false },
      },
    ],
  },
];
